import { render, staticRenderFns } from "./NotificationMessageFormat.vue?vue&type=template&id=34cb8524&scoped=true&"
import script from "./NotificationMessageFormat.vue?vue&type=script&lang=js&"
export * from "./NotificationMessageFormat.vue?vue&type=script&lang=js&"
import style0 from "./NotificationMessageFormat.vue?vue&type=style&index=0&id=34cb8524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cb8524",
  null
  
)

export default component.exports